// extracted by mini-css-extract-plugin
export default {"notification-panel-width":"Notification_notification-panel-width__xNMoz"};